import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {navigateToUrl} from '../../../utilities/StringHelpers/StringHelpers';


const CameBackFromAbroad = ({icon, text, btnText, btnLink, isAfter,  reportDwh}) => {
  return (
    <div className='came-back-from-abroad-wrapper'>
    <div className='came-back-from-abroad'>
      <div className='icon-and-text'>
        {text && <div className='text'>{text}</div>}
        {icon && <Image className='icon' src={icon} alt='icon' />}
      </div>
      {btnText && (
        <div
          className={isAfter ? 'hyper-link-text' : 'gray-btn-text'}
          onClick={() => {
            if (btnLink && isAfter) {
              reportDwh()
              navigateToUrl(btnLink);
            }
          }}>
          {btnText}
        </div>
      )}
    </div>
    </div>
  );
};

export default CameBackFromAbroad;
